import Home from './../views/Home.vue'

// Branch
import CreateUpdateBranch from '../components/Branch/Create.vue'

// Department
import CreateUpdateDepartment from '../components/Department/Create.vue'

// Job Title
import CreateUpdateJobTitle from '../components/JobTitle/Create.vue'

// Holiday
import CreateUpdateHoliday from '../components/Holiday/Create.vue'

// Employee
import EmployeeModule from '../views/Employee/Employee.vue'
import ListOfEmployee from '../components/Employee/List.vue'
import CreateUpdateEmployee from '../components/Employee/CreateEdit.vue'
import EmployeeDocument from '../components/Employee/Document.vue'
import EmployeeJobHistory from '../components/Employee/JobHistory.vue'
import OrganizationalChart from '../components/Employee/OrganizationalChart.vue'

// Payroll
import PayrollModule from '../views/Payroll/Payroll.vue'
import CreateUpdatePayroll from '../components/Payroll/CreateEdit.vue'
import CreateMultiplePayroll from '../components/Payroll/CreateMultiple.vue'
import ListOfPayroll from '../components/Payroll/List.vue'

// TimeSheet
import TimeSheetModule from '../components/TimeSheet/TimeSheet.vue'

// Leave
import LeaveModule from '../views/Leave/Leave.vue'
import CreateEditLeave from '../components/Leave/CreateEdit.vue'
import ListOfLeaves from '../components/Leave/List.vue'

// Newsfeed
import NewsfeedModule from '../views/Newsfeed/Newsfeed'
import ListOfNewsfeed from '../components/Newsfeed/List'
import CreateEditNewsfeed from '../components/Newsfeed/CreateEdit'

// User Management
import UserManagement from '../views/UserManagement/UserManagement.vue'
import CreateUpdateUser from '../components/UserManagement/CreateUpdate.vue'
import ListOfUser from '../components/UserManagement/List.vue'
import Login from '../components/UserManagement/Login.vue'

// 13th Month Pay
import CreateUpdate13thMonthPay from '../components/ThirteenMonthPay/CreateEdit'
import CreateMultiple13thMonthPay from '../components/ThirteenMonthPay/CreateMultiple.vue'
import ListOfThirteenMonthPay from '../components/ThirteenMonthPay/List'
import ThirteenMonthPayModule from '../views/ThirteenMonthPay/ThirteenMonthPay'

// Report
import Report from '../views/Report/Report.vue'

// Document
import Document from '../views/Document/Document.vue'

// import auth service
import AuthService from '../_services/auth'

// Guest Access
import GuestEmployeeTimeSheet from '../views/GuestEmployeeAccess/GuestEmployeeTimeSheet.vue'
import GuestLeaveApproval from '../views/GuestEmployeeAccess/GuestLeaveApproval'

// Timesheets for Modifications
import TimeSheetForModification from '../views/TimeSheetForModification/TimeSheetForModification.vue'
import ListOfTimeSheetForModification from '../components/TimeSheet/ListOfTimeSheetForModification.vue'
import ViewTimeSheetForModification from '../components/TimeSheet/ViewTimeSheetForModification.vue'

// Reset Password
import ResetPass from '../views/ResetPass/ResetPass'
import RequestViaEmail from '../components/ResetPass/Request'
import CreateNewPass from '../components/ResetPass/CreateNewPass'

// Release notes
import ReleaseNotes from '../views/ReleaseNotes'

const authService = new AuthService()

// for requiring global auth
function requireAuth(to, from, next) {
  if (authService.isLoggedIn()) {
    next();
  } else {
    next("/login")
  }
}

const routes = [{
    path: '/',
    name: 'home',
    component: Home,
    beforeEnter: requireAuth
  },
  {
    path: '/release-notes',
    name: 'Release Notes',
    component: ReleaseNotes,
    beforeEnter: requireAuth
  },
  {
    path: '/branches',
    name: 'Manage Branches',
    component: CreateUpdateBranch,
    beforeEnter: requireAuth
  },
  {
    path: '/departments',
    name: 'Manage Department',
    component: CreateUpdateDepartment,
    beforeEnter: requireAuth
  },
  {
    path: '/job-titles',
    name: 'Manage Job Title',
    component: CreateUpdateJobTitle,
    beforeEnter: requireAuth
  },
  {
    path: '/holidays',
    name: 'Manage Holiday',
    component: CreateUpdateHoliday,
    beforeEnter: requireAuth
  },
  {
    path: '/employees',
    name: 'Employee Module',
    component: EmployeeModule,
    beforeEnter: requireAuth,
    children: [{
        path: '/',
        name: 'List Of Employees',
        component: ListOfEmployee
      },
      {
        path: 'create',
        name: 'Create Employee',
        component: CreateUpdateEmployee
      },
      {
        path: 'edit/:employeeId',
        name: 'Edit Employee',
        component: CreateUpdateEmployee
      },
      {
        path: 'document/:employeeId',
        name: 'Document Of Employee',
        component: EmployeeDocument
      },
      {
        path: 'job-history/:employeeId',
        name: 'Job History of Employee',
        component: EmployeeJobHistory
      },
      {
        path: 'organizational-chart',
        name: 'Organizational Chart of Employee',
        component: OrganizationalChart
      }
    ]
  },
  {
    path: '/payrolls',
    name: 'Payroll Module',
    component: PayrollModule,
    beforeEnter: requireAuth,
    children: [{
      path: '/',
      name: 'List Of Payrolls',
      component: ListOfPayroll
    }, {
      path: 'sort-by-payroll-period/:dateFrom/:dateTo',
      name: 'Sort by Payroll Period',
      component: ListOfPayroll
    }, {
      path: 'create',
      name: 'Create Payroll',
      component: CreateUpdatePayroll
    }, {
      path: 'create-bulk',
      name: 'Create Bulk Payroll',
      component: CreateMultiplePayroll
    }, {
      path: 'edit/:payrollId',
      name: 'Edit Payroll',
      component: CreateUpdatePayroll
    }]
  }, {
    path: '/timesheets',
    name: 'TimeSheet Module',
    component: TimeSheetModule,
    beforeEnter: requireAuth
  }, {
    path: '/leaves',
    name: 'Leave Module',
    component: LeaveModule,
    children: [{
        path: '/',
        name: 'List Of Leave',
        component: ListOfLeaves
      }, {
        path: 'create',
        name: 'Create Leave',
        component: CreateEditLeave
      },
      {
        path: 'edit/:leaveId',
        name: 'Edit Leave',
        component: CreateEditLeave
      }
    ]
  },
  {
    path: '/thirteen-month-pays',
    name: 'Thirteen Month Pay Module',
    component: ThirteenMonthPayModule,
    children: [{
        path: '/',
        name: 'List Of 13 Month Pay',
        component: ListOfThirteenMonthPay
      }, {
        path: 'create',
        name: 'Create Thirteen Month Pay',
        component: CreateUpdate13thMonthPay
      },
      {
        path: 'edit/:thirteenMonthPayId',
        name: 'Edit Thirteen Month Pay',
        component: CreateUpdate13thMonthPay
      },
      {
        path: 'create-bulk',
        name: 'Create Bulk 13th Month Pay',
        component: CreateMultiple13thMonthPay
      }
    ]
  }, {
    path: '/newsfeeds',
    name: 'Newsfeed Module',
    component: NewsfeedModule,
    children: [{
        path: '/',
        name: 'List Of Newsfeed',
        component: ListOfNewsfeed
      },
      {
        path: 'create',
        name: 'Create Newsfeed',
        component: CreateEditNewsfeed
      },
      {
        path: 'edit/:newsfeedId',
        name: 'Edit Newsfeed',
        component: CreateEditNewsfeed
      }
    ]
  }, {
    path: '/login',
    component: Login,
    name: 'Login Page',
    beforeEnter: (to, from, next) => {
      if (authService.isLoggedIn()) {
        next('/home')
      } else {
        next()
      }
    }
  }, {
    path: '/documents',
    component: Document,
    name: 'Document',
    beforeEnter: requireAuth,
  }, {
    path: '/reports',
    component: Report,
    name: 'Report Module',
    beforeEnter: requireAuth,
  }, {
    path: '/user-managements',
    component: UserManagement,
    beforeEnter: requireAuth,
    children: [{
      path: '/',
      component: ListOfUser,
      name: 'List of Users'
    }, {
      path: 'create',
      component: CreateUpdateUser,
      name: 'Create User'
    }, {
      path: 'edit/:userId',
      component: CreateUpdateUser,
      name: 'Update User'
    }]

  },
  // Timesheet for Modifications
  {
    path: '/timesheet-for-modifications',
    component: TimeSheetForModification,
    beforeEnter: requireAuth,
    children: [{
      path: '/',
      component: ListOfTimeSheetForModification,
      name: 'List Of TimeSheet for Modification'
    }, {
      path: 'view/:timesheetmodificationId',
      component: ViewTimeSheetForModification,
      name: 'View TimeSheet for Modification'
    }]
  },
  // Guest accesses
  {
    path: '/employee-timesheet/:token',
    component: GuestEmployeeTimeSheet,
    name: 'Guest Employee TimeSheet Access'
  }, {
    path: '/leave-approval/:hashCode/:action/:leaveId/:otherHashCode/:approverEmail',
    component: GuestLeaveApproval,
    name: 'Guest Leave Approval Access'
  },
  {
    path: '/reset-password',
    component: ResetPass,
    children: [{
      path: 'request',
      component: RequestViaEmail,
      name: 'Request'
    },{
      path: 'auth/:token/:code',
      component: CreateNewPass,
      name: 'Auth Create New Password'
    }]
  }
]


export default routes